import { createEntityAdapter } from '@reduxjs/toolkit';
import { ModelError, PostUnderwriteModelApiResponse, UnderwriteModel } from './api-types';
// type ModelErrors = {
//   modelID:number,

// }

export const modelsEntityAdapter = createEntityAdapter<UnderwriteModel>({
    selectId: (m) => m.modelId,
});
export const modelsInitialState = modelsEntityAdapter.getInitialState();
export type ModelsEntityState = typeof modelsInitialState;

///errors part for models
export const modelsErrorsEntityAdapter = createEntityAdapter<{
    modelID: number;
    errors: Required<Pick<ModelError, 'error' | 'createdOn'>>[];
}>({
    selectId: (slice) => slice.modelID,
    // sortComparer: (a, b) => a.modelID - b.modelID,
});
export const modelsErrorsInitialState = modelsErrorsEntityAdapter.getInitialState();
export type ModelsErrorsEntityState = typeof modelsErrorsInitialState;
